import { render, staticRenderFns } from "./EditTripPhoto.vue?vue&type=template&id=dbc06c70&scoped=true&"
import script from "./EditTripPhoto.vue?vue&type=script&lang=js&"
export * from "./EditTripPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc06c70",
  null
  
)

export default component.exports